export default __webpack_public_path__ + "static/media/Cruelty.7e78bf14.png";